import { useState, useEffect } from "react";
import { Stack, Typography, Autocomplete, TextField } from "@mui/material";
import NetworkShell from "../Shell/NetworkShell";
import useFetchAgentsOptions from "../../../sharedhooks/Agents/useFetchAllAgents";
import useUpdateHierarchy from "../hooks/useUpdateHieararchy";

export default function AdminNetwork() {
	const [currentAgent, setCurrentAgent] = useState(null);
	const { agents, loading: agentOptionsLoading } = useFetchAgentsOptions();
	const { updateHierarchy, loading: updateHierarchyLoading } = useUpdateHierarchy();

	useEffect(() => {
		if (agents?.length > 0 && !currentAgent) {
			setCurrentAgent(agents[0]);
		}
	}, [agents, currentAgent]);

	const header = (
		<Stack
			direction={{ xs: "column", sm: "row" }}
			alignItems={{ xs: "flex-start", sm: "center" }}
			spacing={{ xs: 0.75, sm: 2 }}
			width={{ xs: "100%", lg: "auto" }}
		>
			<Typography fontWeight={600} sx={{ fontSize: { xs: 13, sm: 14 }, whiteSpace: "nowrap" }}>
				Current Agent:
			</Typography>
			<Autocomplete
				size="small"
				options={agents || []}
				loading={agentOptionsLoading}
				value={currentAgent}
				onChange={(e, newValue) => setCurrentAgent(newValue)}
				getOptionLabel={(option) => option?.display_name || ""}
				isOptionEqualToValue={(option, value) => option?.ID === value?.ID}
				sx={{
					width: { xs: "100%", sm: 220, md: 250 },
					"& .MuiButtonBase-root": {
						backgroundColor: "transparent",
						"&:hover": { color: "#1D54A2" },
					},
				}}
				slotProps={{
					popper: {
						sx: {
							"& .MuiAutocomplete-paper": { width: "inherit !important" },
						},
					},
				}}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder="Select agent"
						sx={{
							"& .MuiInputBase-input": {
								padding: { xs: "6px 10px", sm: "8.5px 14px" },
								fontSize: { xs: 13, sm: 14 },
							},
							"& fieldset": { borderColor: "#4E4E4E !important" },
							"&:hover fieldset": { borderColor: "#4E4E4E !important" },
							"&.Mui-focused fieldset": { borderColor: "#4E4E4E !important" },
							"& .MuiAutocomplete-input": { border: "none !important" },
						}}
					/>
				)}
			/>
		</Stack>
	);

	return (
		<NetworkShell
			userId={currentAgent?.ID}
			currentAgent={currentAgent}
			headerSlot={header}
			updateHierarchy={updateHierarchy}
			updateHierarchyLoading={updateHierarchyLoading}
		/>
	);
}
